import moment from 'moment';

export const getPerformanceWeekStart = (): moment.Moment => {
  const referenceDate = moment();

  // If the weekday is 5AM Wednesday or after, use this week's Wednesday; Otherwise use last week's.
  return referenceDate.weekday() > 3 || (referenceDate.weekday() === 3 && referenceDate.hour() >= 5) ?
    referenceDate
      .set({ weekday: 3, hour: 5, minute: 0, second: 0, millisecond: 0 }) :
    referenceDate
      .set({ weekday: 3, hour: 5, minute: 0, second: 0, millisecond: 0 })
      .subtract({ weeks: 1 });
};

export const getPerformanceWeekEndForDate = (referenceDate: moment.Moment): moment.Moment => {

  // If the weekday is 5AM Wednesday or after, use this week's Wednesday; Otherwise use last week's.
  return referenceDate.weekday() > 3 || (referenceDate.weekday() === 3 && referenceDate.hour() >= 5) ?
    referenceDate
      .set({ weekday: 3, hour: 5, minute: 0, second: 0, millisecond: 0 })
      .add({ weeks: 1 }) :
    referenceDate
      .set({ weekday: 3, hour: 5, minute: 0, second: 0, millisecond: 0 });
};

export const getPerformanceWeekEnd = (): moment.Moment => {
  const referenceDate = moment();

  // If the weekday is 5AM Wednesday or after, use this week's Wednesday; Otherwise use last week's.
  return referenceDate.weekday() > 3 || (referenceDate.weekday() === 3 && referenceDate.hour() >= 5) ?
    referenceDate
      .set({ weekday: 3, hour: 5, minute: 0, second: 0, millisecond: 0 })
      .add({ weeks: 1 }) :
    referenceDate
      .set({ weekday: 3, hour: 5, minute: 0, second: 0, millisecond: 0 });
};

